// services/divisionService.js
import { divisionsAPI } from './api';

export const divisionService = {
  async getDivisions() {
    try {
      const response = await divisionsAPI.getAll();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching divisions:', error);
      throw new Error(error.response?.data?.message || 'Failed to load divisions');
    }
  },

  async getDivision(id) {
    try {
      const response = await divisionsAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching division:', error);
      throw new Error(error.response?.data?.message || 'Failed to load division');
    }
  },

  async createDivision(division) {
    try {
      console.log('📤 Creating division:', division);
      const response = await divisionsAPI.create(division);
      console.log('✅ Division created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating division:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to create division';
      throw new Error(errorMessage);
    }
  },

  async updateDivision(id, division) {
    try {
      console.log(`📤 Updating division ${id}:`, division);
      const response = await divisionsAPI.update(id, division);
      console.log('✅ Division updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating division:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to update division';
      throw new Error(errorMessage);
    }
  },

  async deleteDivision(id) {
    try {
      await divisionsAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting division:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete division');
    }
  }
};